import KbdShortcut from '@modules/commandPalette/components/KbdShortcut';
import { Stack, Tooltip, TooltipProps, Typography } from '@mui/material';
import { ReactElement } from 'react';

interface CommandTooltipProps {
  children: ReactElement;
  name?: string;
  shortcut?: string[];
  placement?: TooltipProps['placement'];
}

export function CommandTooltip({
  children,
  name,
  shortcut,
  placement = 'top',
}: CommandTooltipProps) {
  if (!name && !shortcut) {
    return children;
  }

  return (
    <Tooltip
      arrow
      placement={placement}
      title={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {name ? <Typography variant="caption">{name}</Typography> : null}
          {shortcut ? <KbdShortcut code={shortcut} /> : null}
        </Stack>
      }
      children={children}
    />
  );
}
